import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import _ from "lodash";
import { useSelector } from "react-redux";

import Socket from "../../../socket/socket";
import Alert from "../../../components/shared/common/alert";
import crossIcon from "../../../assets/images/landing-library/cross-icon.png";
import dropdownArrow from "../../../assets/images/landing-library/dropdown-arrow.png";

const Footer = ({
  link,
  teamCode,
  sessionId,
  sessionUsers,
  team_session,
  goingUp = false
}) => {
  const active_text = _.get(team_session, "active_text", "Active Session:");
  const members_text = _.get(team_session, "members_text", "Members");
  const join_text = _.get(team_session, "join_text");

  const sessionIdFromReducer = useSelector(
    (state) => state.gameReducer?.sessionObj?.session_id
  );

  const [toggleQRCode, setToggleQRCode] = useState(true);
  const [toggleMembers, setToggleMembers] = useState(true);

  useEffect(() => {
    return Socket.addListener("session-kick", (data) => {
      Alert(200, `${data.leaving_player.display_name} removed Successfully`);
    });
  }, []);

  useEffect(() => {
    setToggleMembers(false);
  }, []);

  useEffect(() => {
    if (goingUp) {
      link !== undefined && setToggleQRCode(true);
    } else {
      setToggleQRCode(false);
    }
  }, [link, goingUp]);

  const handleToggleMembers = () =>
    !_.isEmpty(sessionUsers) && setToggleMembers((prev) => !prev);

  const handleToggleQrCode = () =>
    link !== undefined && setToggleQRCode((prev) => !prev);

  const handleRemoveUser = (playerId) => {
    let data = {
      action: "session-kick",
      sessionId: sessionId === "" ? sessionIdFromReducer : sessionId,
      teamCode,
      playerId
    };
    Socket.sendMessage(data);
  };

  const copySessionCode = () => {
    let copyToClip = sessionId;
    var textArea = document.createElement("textarea");
    document.body.append(textArea);
    document.body.lastElementChild.value = copyToClip;
    document.body.lastElementChild.select();
    document.execCommand("copy");
    textArea.remove();
    Alert(200, "Code copied successfully");
  };

  return (
    <div className="session-footer">
      <div className="active-members">
        <span className="">{active_text}</span>
        <div className="toggle-members" onClick={handleToggleMembers}>
          <p>
            {sessionUsers?.length}
            {"  "}
            {members_text}
          </p>
          <img
            alt=""
            src={dropdownArrow}
            className={!toggleMembers ? "arrow-reverse" : ""}
          />
          {toggleMembers && !_.isEmpty(sessionUsers) && (
            <div
              className="bottom-members-wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="members-inner">
                {sessionUsers?.map((value, index) => (
                  <div key={index} className="members-div">
                    <div className="member-info">
                      <img
                        alt=""
                        src={value.profile_image}
                        className="member-avatar"
                      />
                      <span className="member-name">{value.display_name}</span>
                    </div>
                    <img
                      alt=""
                      src={crossIcon}
                      className="cross-icon"
                      onClick={() => handleRemoveUser(value.player_id)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="join-qr-code">
        <p>{join_text}</p>
        <span onClick={copySessionCode} className="underline">
          {sessionId}
        </span>
        <div className="toggle-qr-code" onClick={handleToggleQrCode}>
          <span>{toggleQRCode ? "Hide QR Code" : "Show QR Code"}</span>
          <img
            alt=""
            src={dropdownArrow}
            className={!toggleQRCode ? "arrow-reverse" : ""}
          />
          {toggleQRCode && (
            <div
              className="bottom-qrcode-wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              {link !== undefined && (
                <QRCode
                  value={link && link !== "" ? link : "Loading"}
                  size={115}
                  bgColor="transparent"
                  fgColor="#fff"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
